import React from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";

import * as Objects from "../../services/api";

const TemplateRowAction: React.FC<{ template: Objects.Template }> = ({ template }) => {
  const navigate = useNavigate();
  const isCreate = template.id === null;
  const handleRowActionButton = () => {
    if (isCreate) {
      navigate(`/templates/create/${template.name}`);
    } else {
      navigate("/templates/edit", {
        state: {
          template: {
            id: template.id,
            name: template.name,
            prefix: template.prefix,
            color_space: template.color_space,
            segment_length: template.segment_length,
            set_ids: template.set_ids,
          },
        },
      });
    }
  };

  return (
    <Button size="small" variant="contained" onClick={handleRowActionButton}>
      {isCreate ? "Add" : "Edit"}
    </Button>
  );
};

export default TemplateRowAction;
